import React, { useState } from "react";
import { getContainer } from "../../ioc/IOCSetup";
import { Product } from "../../http/protocol";
import { UserService } from "../../services/UserService";
import { Form, FormListener } from "../form/Form";
import { FormGroup } from "../form/FormGroup";
import { SelectInput } from "../form/SelectInput";
import { Submit } from "../form/Submit";
import { UserActionContainerProps, UpdateActionStatus, UserActionContainer } from "./UserActionContainer";

export const UserProducts: React.FC<UserActionContainerProps> = (props: UserActionContainerProps) => {

    const userService: UserService = getContainer().getUserService();
    const [form, setForm] = useState<{[product:string]: Product | undefined}>({ product: undefined });


    function submit(enabled: boolean) {
        let selectedProduct = form.product;
        if (!selectedProduct) return;
        if (!props.users) return;
        let users = [...props.users || []];
        for (let i = 0; i < users.length; i++) {
            users[i].status = UpdateActionStatus.PENDING;
            users[i].description = `Prepared to ` + (enabled ? `enable ` : `disable `) + ` product "${selectedProduct}"`;
            users[i].request = () => new Promise<{ status: UpdateActionStatus; description: string; response: any; }>((resolve, reject) => {
                userService.updateProductEnabled(users[i].id, selectedProduct!, enabled)
                    .then((response) => {
                        resolve({ status: UpdateActionStatus.OK, description: (enabled ? `Enabled ` : `Disabled`) + ` product "${selectedProduct}"`, response: response });
                    })
                    .catch((error) => {
                        console.log("User test error", error);
                        resolve({ status: UpdateActionStatus.FAIL, description: "Failed " + (enabled ? `enabling ` : `disabling`) + ` product "${selectedProduct}"`, response: error });
                    });
            });
        }
        if (props.updateUsers) props.updateUsers(users);
    }

    const ref: FormListener<any> = {
        formDidUpdate: (formModel: any, validationMap: any) => {
            setForm(formModel);
        },
        onSubmit: () => {
            submit(true);
        }
    };
    return (
        <UserActionContainer title={"User Products"}>
            <Form className="form-horizontal" formListener={ref} modelObject={form} validationMap={{}}>
                <FormGroup className="form-group row">
                    <div className="col-sm-8">
                        <SelectInput className="form-control" model="product" optional={true} values={Object.keys(Product)}></SelectInput>
                    </div>
                    <div className="col-sm-4">
                        <Submit className="btn btn-primary">Enabled</Submit>
                        <Submit className="btn btn-danger" onClick={(e) => { e.preventDefault(); submit(false); }}>Disable
                        </Submit>
                    </div>
                    <span className={"help-block col"}>Choose a Product to enabled or disable. Current selected product: {form && form.product!}</span>
                </FormGroup>
            </Form>
        </UserActionContainer>
    );

};
